module.exports = __webpack_public_path__ + "img/Assign_with_Template.49fd4a8b.svg";